import { Box, Button, IconButton, MenuItem, Select, TextField, Typography } from "@mui/material";
import { AVAILABLE_ICONS, ICONS } from "components/Icons";
import React from "react";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

export const HowItWorksSection = ({ value, onChange }) => {
  const items = value?.howItWorks || [];

  const handleAddItem = () => {
    const newItems = [...items, { item: items.length + 1, iconName: "", description: "" }];
    const newValue = { ...value, howItWorks: newItems };
    onChange({
      target: {
        name: "displayOptions",
        value: newValue
      }
    });
  };

  const handleRemoveItem = (index) => {
    const newItems = items.filter((_, i) => i !== index).map((item, i) => ({
      ...item,
      item: i + 1
    }));
    const newValue = { ...value, howItWorks: newItems };
    onChange({
      target: {
        name: "displayOptions",
        value: newValue
      }
    });
  };

  const handleItemChange = (index, field, newValue) => {
    const newItems = [...items];
    newItems[index] = { ...newItems[index], [field]: newValue };
    const updatedValue = { ...value, howItWorks: newItems };
    onChange({
      target: {
        name: "displayOptions",
        value: updatedValue
      }
    });
  };

  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h4" sx={{ mb: 2 }}>How It Works</Typography>
      {items.map((item, index) => (
        <Box key={index} sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <Select
            value={item.iconName}
            onChange={(e) => handleItemChange(index, "iconName", e.target.value)}
            sx={{ mr: 2, minWidth: 120 }}
          >
            {AVAILABLE_ICONS.map((iconName) => {
              const Icon = ICONS[iconName];
              return (
                <MenuItem key={iconName} value={iconName}>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Icon style={{ marginRight: 8, width: 24, height: 24 }} />
                    {iconName}
                  </Box>
                </MenuItem>
              );
            })}
          </Select>
          <TextField
            fullWidth
            value={item.description}
            onChange={(e) => handleItemChange(index, "description", e.target.value)}
            placeholder="Enter description"
          />
          <IconButton onClick={() => handleRemoveItem(index)} sx={{ ml: 1 }}>
            <DeleteIcon />
          </IconButton>
        </Box>
      ))}
      <Button
        startIcon={<AddIcon />}
        onClick={handleAddItem}
        variant="outlined"
        sx={{ mt: 1 }}
      >
        Add Step
      </Button>
    </Box>
  );
};
